<template>
    <CalendarCell
        :class="cn('[relative border-none p-0 text-center text-sm focus-within:relative focus-within:z-20', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarCell>
</template>

<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarCellProps } from 'reka-ui';
import { CalendarCell, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarCellProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
